import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ownerApi, apiErrorText } from "@/lib/ownerApi";

export default function GoogleAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    ownerApi.post("/auth/google", { session_id: sessionId })
      .then(() => navigate("/admin", { replace: true }))
      .catch((err) => navigate("/owner", { replace: true, state: { error: apiErrorText(err) } }));
  }, [location.hash, navigate]);

  return <div data-testid="google-auth-callback" className="min-h-screen" />;
}
